import { PortfolioBar } from '../components/PortfolioBar'
import { PortfolioValueChart } from '../components/PortfolioValueChart'
import { ChartErrorBoundary } from '../components/chart/ChartErrorBoundary'

export function HomePage() {
  return (
    <div className="divide-y divide-zinc-800">
      <ChartErrorBoundary>
        <PortfolioValueChart />
      </ChartErrorBoundary>
      <PortfolioBar />
    </div>
  )
}
